import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { handleApplyNow } from '../../Utils/navigation';

const InterestCalculator = () => {
  const navigate = useNavigate();
  const [loanAmount, setLoanAmount] = useState(5000);
  const [loanTenure, setLoanTenure] = useState(1);
  const [interestRate, setInterestRate] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);

  const styles = {
    container: {
      width: '100%',
      maxWidth: '100%',
      margin: '0',
      padding: '6rem 4rem',
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(20px)',
      borderRadius: '24px',
      border: '1px solid rgba(226, 232, 240, 0.8)',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    },
    containerBefore: {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.05) 0%, rgba(30, 58, 138, 0.05) 100%)',
      borderRadius: '24px',
      zIndex: '-1'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '800',
      background: 'linear-gradient(135deg, #ff6b35, #1e3a8a)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      marginBottom: '2rem',
      textAlign: 'center',
      letterSpacing: '-0.02em',
      height: '50px'
    },
    subtitle: {
      fontSize: '1.1rem',
      color: '#64748b',
      textAlign: 'center',
      marginBottom: '3rem',
      fontWeight: '400'
    },
    contentWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '3rem',
      alignItems: 'start'
    },
    slidersSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2.5rem'
    },
    sliderSection: {
      background: 'rgba(255, 255, 255, 0.8)',
      padding: '2rem',
      borderRadius: '16px',
      border: '1px solid rgba(226, 232, 240, 0.6)',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease'
    },
    sliderSectionHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 24px rgba(255, 107, 53, 0.15)',
      borderColor: '#ff6b35'
    },
    label: {
      display: 'flex',
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '1rem',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    valueDisplay: {
      fontSize: '1.5rem',
      fontWeight: '700',
      background: 'linear-gradient(135deg, #ff6b35, #1e3a8a)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      textAlign: 'right'
    },
    slider: {
      width: '100%',
      height: '8px',
      borderRadius: '4px',
      outline: 'none',
      cursor: 'pointer',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
      background: '#e2e8f0',
      marginTop: '1rem'
    },
    resultsSection: {
      background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(30, 58, 138, 0.1))',
      padding: '2.5rem',
      borderRadius: '20px',
      border: '1px solid rgba(255, 107, 53, 0.2)',
      position: 'relative',
      overflow: 'hidden'
    },
    resultsSectionBefore: {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      background: 'radial-gradient(circle at 20% 80%, rgba(255, 107, 53, 0.1) 0%, transparent 50%)',
      borderRadius: '20px'
    },
    resultRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1.25rem 0',
      borderBottom: '1px solid rgba(226, 232, 240, 0.6)',
      fontSize: '1.1rem'
    },
    resultRowLast: {
      borderBottom: 'none',
      paddingBottom: '0',
      marginTop: '1rem',
      paddingTop: '1.5rem',
      borderTop: '2px solid rgba(255, 107, 53, 0.3)'
    },
    resultLabel: {
      color: '#475569',
      fontWeight: '500',
      fontSize: '1rem'
    },
    resultValue: {
      color: '#1e293b',
      fontWeight: '700',
      fontSize: '1.25rem'
    },
    resultValueHighlight: {
      background: 'linear-gradient(135deg, #ff6b35, #1e3a8a)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontSize: '1.5rem',
      fontWeight: '800'
    },
    button: {
      width: '100%',
      background: 'linear-gradient(135deg, #ff6b35, #1e3a8a)',
      border: 'none',
      color: 'white',
      padding: '1.5rem 2rem',
      borderRadius: '16px',
      fontWeight: '700',
      fontSize: '1.2rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.75rem',
      transition: 'all 0.3s ease',
      marginTop: '2rem',
      boxShadow: '0 8px 24px rgba(255, 107, 53, 0.3)',
      position: 'relative',
      overflow: 'hidden'
    },
    buttonHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 32px rgba(255, 107, 53, 0.4)'
    },
    icon: {
      width: '1.25rem',
      height: '1.25rem',
      color: 'white'
    },
    emiBreakdown: {
      marginTop: '2rem',
      padding: '1.5rem',
      background: 'rgba(255, 255, 255, 0.8)',
      borderRadius: '12px',
      border: '1px solid rgba(226, 232, 240, 0.6)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100% !important',
      maxWidth: '1200px',
      textAlign: 'center'
    },
    emiTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#475569',
      marginBottom: '1rem',
      textAlign: 'center'
    },
    emiGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '1rem',
      maxWidth: '600px',
      margin: '0 auto'
    },
    emiItem: {
      textAlign: 'center',
      padding: '1rem',
      background: 'rgba(255, 255, 255, 0.6)',
      borderRadius: '8px',
      border: '1px solid rgba(226, 232, 240, 0.4)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    emiLabel: {
      fontSize: '0.875rem',
      color: '#64748b',
      fontWeight: '500',
      marginBottom: '0.5rem'
    },
    emiValue: {
      fontSize: '1.125rem',
      fontWeight: '700',
      color: '#1e293b'
    }
  };

  useEffect(() => {
    const principal = loanAmount;
    const dailyRate = interestRate / 100;
    const days = loanTenure;

    // Daily interest calculation for payday loans
    const dailyInterest = principal * dailyRate * days;
    const totalAmount = principal + dailyInterest;

    setMonthlyEMI(Math.round(dailyInterest / days)); // Daily interest amount
    setTotalInterest(Math.round(dailyInterest));
    setTotalAmount(Math.round(totalAmount));
  }, [loanAmount, loanTenure, interestRate]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const getSliderBackground = (value, min, max) => {
    const percentage = ((value - min) / (max - min)) * 100;
    return `linear-gradient(to right, #ff6b35 0%, #1e3a8a ${percentage}%, #e2e8f0 ${percentage}%, #e2e8f0 100%)`;
  };

  const sliderStyles = `
    .modern-slider {
      -webkit-appearance: none;
      appearance: none;
      height: 8px;
      border-radius: 4px;
      outline: none;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .modern-slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      height: 24px;
      width: 24px;
      border-radius: 50%;
      background: linear-gradient(135deg, #ff6b35, #1e3a8a);
      cursor: pointer;
      box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
      border: 3px solid white;
      transition: all 0.3s ease;
    }

    .modern-slider::-moz-range-thumb {
      height: 24px;
      width: 24px;
      border-radius: 50%;
      background: linear-gradient(135deg, #ff6b35, #1e3a8a);
      cursor: pointer;
      box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
      border: 3px solid white;
      transition: all 0.3s ease;
    }

    .modern-slider:focus {
      outline: none;
    }

    .modern-slider:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 4px rgba(255, 107, 53, 0.2), 0 4px 12px rgba(255, 107, 53, 0.4);
      transform: scale(1.1);
    }

    .modern-slider:focus::-moz-range-thumb {
      box-shadow: 0 0 0 4px rgba(255, 107, 53, 0.2), 0 4px 12px rgba(255, 107, 53, 0.4);
      transform: scale(1.1);
    }

    .modern-slider:hover::-webkit-slider-thumb {
      transform: scale(1.1);
    }

    .modern-slider:hover::-moz-range-thumb {
      transform: scale(1.1);
    }

    .modern-button:hover {
      transform: translateY(-2px) !important;
      box-shadow: 0 12px 32px rgba(255, 107, 53, 0.4) !important;
    }

    .slider-section:hover {
      transform: translateY(-2px) !important;
      box-shadow: 0 8px 24px rgba(255, 107, 53, 0.15) !important;
      border-color: #ff6b35 !important;
    }

    @media (max-width: 768px) {
      .calculator-container {
        padding: 2rem 1rem !important;
        margin: 0 !important;
        border-radius: 16px !important;
      }
      
      .calculator-title {
        font-size: 2rem !important;
        height: auto !important;
        line-height: 1.3 !important;
        margin-bottom: 1rem !important;
      }
      
      .calculator-subtitle {
        font-size: 1rem !important;
        margin-bottom: 1.5rem !important;
        padding: 0 0.5rem !important;
      }
      
      .content-wrapper {
        grid-template-columns: 1fr !important;
        gap: 2rem !important;
      }
      
      .slider-section {
        padding: 1.5rem !important;
        border-radius: 12px !important;
      }
      
      .slider-label {
        font-size: 1rem !important;
        margin-bottom: 0.75rem !important;
        flex-wrap: wrap !important;
        gap: 0.5rem !important;
      }
      
      .slider-value {
        font-size: 1.25rem !important;
      }
      
      .results-section {
        padding: 2rem !important;
        border-radius: 16px !important;
      }
      
      .result-row {
        padding: 1rem 0 !important;
        font-size: 1rem !important;
        flex-wrap: wrap !important;
        gap: 0.25rem !important;
      }
      
      .result-label {
        font-size: 0.9rem !important;
      }
      
      .result-value {
        font-size: 1.1rem !important;
      }
      
      .result-value-highlight {
        font-size: 1.25rem !important;
      }
      
      .emi-breakdown {
        margin-top: 1.5rem !important;
        padding: 1.25rem !important;
        border-radius: 10px !important;
      }
      
      .emi-title {
        font-size: 0.95rem !important;
        margin-bottom: 0.75rem !important;
      }
      
      .emi-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 0.875rem !important;
      }
      
      .emi-item {
        padding: 0.875rem !important;
        border-radius: 6px !important;
      }
      
      .emi-label {
        font-size: 0.8rem !important;
        margin-bottom: 0.375rem !important;
      }
      
      .emi-value {
        font-size: 1rem !important;
      }
      
      .modern-button {
        padding: 1.25rem 1.75rem !important;
        font-size: 1.1rem !important;
        border-radius: 12px !important;
        margin-top: 1.5rem !important;
      }
    }
    
    @media (max-width: 480px) {
      .calculator-container {
        padding: 1.5rem 0.75rem !important;
        border-radius: 12px !important;
      }
      
      .calculator-title {
        font-size: 1.5rem !important;
        margin-bottom: 0.75rem !important;
      }
      
      .calculator-subtitle {
        font-size: 0.9rem !important;
        margin-bottom: 1.25rem !important;
      }
      
      .content-wrapper {
        gap: 1.5rem !important;
      }
      
      .slider-section {
        padding: 1.25rem !important;
        border-radius: 10px !important;
      }
      
      .slider-label {
        font-size: 0.95rem !important;
        margin-bottom: 0.5rem !important;
      }
      
      .slider-value {
        font-size: 1.1rem !important;
      }
      
      .results-section {
        padding: 1.5rem !important;
        border-radius: 12px !important;
      }
      
      .result-row {
        padding: 0.875rem 0 !important;
        font-size: 0.9rem !important;
      }
      
      .result-label {
        font-size: 0.85rem !important;
      }
      
      .result-value {
        font-size: 1rem !important;
      }
      
      .result-value-highlight {
        font-size: 1.1rem !important;
      }
      
      .emi-breakdown {
        margin-top: 1.25rem !important;
        padding: 1rem !important;
        border-radius: 8px !important;
      }
      
      .emi-title {
        font-size: 0.875rem !important;
        margin-bottom: 0.5rem !important;
      }
      
      .emi-grid {
        grid-template-columns: 1fr !important;
        gap: 0.75rem !important;
      }
      
      .emi-item {
        padding: 0.75rem !important;
        border-radius: 6px !important;
      }
      
      .emi-label {
        font-size: 0.75rem !important;
        margin-bottom: 0.25rem !important;
      }
      
      .emi-value {
        font-size: 0.95rem !important;
      }
      
      .modern-button {
        padding: 1rem 1.5rem !important;
        font-size: 1rem !important;
        border-radius: 10px !important;
        margin-top: 1.25rem !important;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: sliderStyles }} />
      <div className="calculator-container" style={styles.container}>
        <div style={styles.containerBefore}></div>
        
        <h1 className="calculator-title" style={styles.title}>Personal Loan Calculator</h1>
        <p className="calculator-subtitle" style={styles.subtitle}>Calculate your daily interest and plan your short-term loan repayment</p>
        
        <div className="content-wrapper" style={styles.contentWrapper}>
          {/* Left Section - Sliders */}
          <div style={styles.slidersSection}>
            {/* Loan Amount Slider */}
            <div className="slider-section" style={styles.sliderSection}>
              <label className="slider-label" style={styles.label}>
                <span>Loan Amount</span>
                <span className="slider-value" style={styles.valueDisplay}>₹{formatCurrency(loanAmount)}</span>
              </label>
              <input
                type="range"
                min="1000"
                max="100000"
                step="1000"
                value={loanAmount}
                onChange={(e) => setLoanAmount(parseInt(e.target.value))}
                className="modern-slider"
                style={{
                  ...styles.slider,
                  background: getSliderBackground(loanAmount, 1000, 100000)
                }}
              />
            </div>

            {/* Loan Tenure Slider */}
            <div className="slider-section" style={styles.sliderSection}>
              <label className="slider-label" style={styles.label}>
                <span>Loan Tenure (Days)</span>
                <span className="slider-value" style={styles.valueDisplay}>{loanTenure} days</span>
              </label>
              <input
                type="range"
                min="1"
                max="30"
                step="1"
                value={loanTenure}
                onChange={(e) => setLoanTenure(parseInt(e.target.value))}
                className="modern-slider"
                style={{
                  ...styles.slider,
                  background: getSliderBackground(loanTenure, 1, 30)
                }}
              />
            </div>

            {/* Interest Rate Slider */}
            <div className="slider-section" style={styles.sliderSection}>
              <label className="slider-label" style={styles.label}>
                <span>Daily Interest Rate (%)</span>
                <span className="slider-value" style={styles.valueDisplay}>{interestRate}</span>
              </label>
              <input
                type="range"
                min="0.25"
                max="2"
                step="0.25"
                value={interestRate}
                onChange={(e) => setInterestRate(parseFloat(e.target.value))}
                className="modern-slider"
                style={{
                  ...styles.slider,
                  background: getSliderBackground(interestRate, 0.25, 2)
                }}
              />
            </div>
          </div>

          {/* Right Section - Results and Button */}
          <div style={styles.rightSection}>
            {/* Results Section */}
            <div className="results-section" style={styles.resultsSection}>
              <div style={styles.resultsSectionBefore}></div>
              
              <div className="result-row" style={styles.resultRow}>
                <span className="result-label" style={styles.resultLabel}>Loan Amount:</span>
                <span className="result-value" style={styles.resultValue}>₹{formatCurrency(loanAmount)}</span>
              </div>

              <div className="result-row" style={styles.resultRow}>
                <span className="result-label" style={styles.resultLabel}>Daily Interest Rate:</span>
                <span className="result-value" style={styles.resultValue}>{interestRate}% per day</span>
              </div>

              <div className="result-row" style={styles.resultRow}>
                <span className="result-label" style={styles.resultLabel}>Loan Tenure:</span>
                <span className="result-value" style={styles.resultValue}>{loanTenure} days</span>
              </div>

              <div className="result-row" style={styles.resultRow}>
                <span className="result-label" style={styles.resultLabel}>Daily Interest:</span>
                <span className="result-value-highlight" style={styles.resultValueHighlight}>₹{formatCurrency(monthlyEMI)}</span>
              </div>

              <div className="result-row" style={styles.resultRow}>
                <span className="result-label" style={styles.resultLabel}>Total Interest:</span>
                <span className="result-value" style={styles.resultValue}>₹{formatCurrency(totalInterest)}</span>
              </div>

              <div className="result-row" style={{...styles.resultRow, ...styles.resultRowLast}}>
                <span className="result-label" style={styles.resultLabel}>Total Amount:</span>
                <span className="result-value-highlight" style={styles.resultValueHighlight}>₹{formatCurrency(totalAmount)}</span>
              </div>
            </div>

            {/* Loan Breakdown - Centered */}
            <div className="emi-breakdown" style={{...styles.emiBreakdown, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <div style={{width: '100% !important', maxWidth: '1200px', textAlign: 'center'}}>
                <div className="emi-title" style={styles.emiTitle}>Loan Breakdown</div>
                <div className="emi-grid" style={{...styles.emiGrid, margin: '0 auto'}}>
                  <div className="emi-item" style={styles.emiItem}>
                    <div className="emi-label" style={styles.emiLabel}>Principal</div>
                    <div className="emi-value" style={styles.emiValue}>₹{formatCurrency(loanAmount)}</div>
                  </div>
                  <div className="emi-item" style={styles.emiItem}>
                    <div className="emi-label" style={styles.emiLabel}>Interest</div>
                    <div className="emi-value" style={styles.emiValue}>₹{formatCurrency(totalInterest)}</div>
                  </div>
                  <div className="emi-item" style={styles.emiItem}>
                    <div className="emi-label" style={styles.emiLabel}>Total</div>
                    <div className="emi-value" style={styles.emiValue}>₹{formatCurrency(totalAmount)}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Apply Now Button */}
            <button className="modern-button" style={styles.button} onClick={() => handleApplyNow(navigate)}>
              <span>Apply for Loan Now</span>
              <svg style={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterestCalculator;